/*
 * Copyright (c) 2008-2022 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
 * This is CONFIDENTIAL code. Use is subject to license terms.
 */

export const PERMISSIONS = Object.freeze({
  //MEETINGS
  CREATE_MEETING: "createMeeting",
  VIEW_MEETING: "viewMeeting",
  EXPORT_MEETING: "exportMeeting",
  UPDATE_MEETING: "updateMeeting",
  RESET_MEETING: "resetMeeting",
  DELETE_MEETING: "deleteMeeting",
  UPDATE_MEETING_ENABLE_DISABLE_STATUS: "updateMeetingEnableDisableStatus",
  VIEW_MEETING_HIDDEN: "viewMeetingHidden",
  //MEETING AUTOJOIN
  VIEW_AUTOJOIN_MEETING: "viewAutoJoinMeeting",
  EDIT_AUTOJOIN_MEETING: "editAutoJoinMeeting",
  //MEETING PROPERTY CRUD
  UPDATE_MEETING_PROPERTY: "updateMeetingProperty",
  DELETE_MEETING_PROPERTY: "deleteMeetingProperty",
  //PARTICIPANT USERS
  CREATE_PARTICIPANT_USER: "createParticipantUser",
  UPLOAD_PARTICIPANT_USER: "uploadParticipantUser",
  DOWNLOAD_PARTICIPANT_USER: "downloadParticipantUser",
  VIEW_PARTICIPANT_USER: "viewParticipantUser",
  UPLOAD_PARTICIPANT_USER_PASSWORD: "updateParticipantUserPassword",
  UPDATE_PARTICIPANT_USER_PROPERTIES: "updateParticipantUserProperties",
  DELETE_PARTICIPANT_USER: "deleteParticipantUser",
  CONTROL_WAITING_ROOM: "controlWaitingRoom",
  LOGOUT_PARTICIPANT_USER: "logoutParticipantUser",
  UPDATE_PARTICIPANT_USER_ACCREDITATION: "updateParticipantUserAccreditation",
  //LIVE MEETING ACTIONS
  NAVIGATE: "navigate",
  VIEW_CONTRIBUTION: "viewContribution",
  CREATE_CONTRIBUTION: "createContribution",
  UPDATE_CONTRIBUTION: "updateContribution",
  DELETE_CONTRIBUTION: "deleteContribution",
  //INTERACTIONS
  VIEW_INTERACTION: "viewInteraction",
  CREATE_INTERACTION: "createInteraction",
  MOVE_INTERACTION: "moveInteraction",
  UPDATE_INTERACTION: "updateInteraction",
  RESET_INTERACTION: "resetInteraction",
  DELETE_INTERACTION: "deleteInteraction",
  //EXPORTS AND RESULTS
  VIEW_EXPORT: "viewExport",
  QUERY_RQL: "queryRql",
  //MEETING ROLES
  VIEW_USER_ROLE_MEETING: "viewUserRoleMeeting",
  UPDATE_USER_ROLE_MEETING: "updateUserRoleMeeting",
  VIEW_MEETING_USER: "viewMeetingUser",
  USE_CLUSTER_VIEW: "useClusterView",
  USE_QA_FACILITATOR_VIEW: "useQaFacilitatorView",
  USE_ELECTION_COMMISSION_VIEW: "useElectionCommissionView",
})
